<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Adicionar Cliente"
    type-modal="add_customer_modal"
  >
    <div class="modal-content__main">
      <customer-form ref="customerForm"/>
    </div>

    <div slot="actions" class="modal-content__control" >
      <loader v-if="loading" :fullPage="false" class="mr-4"/>
      <d-button
        type="button"
        :disabled="loading"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import CustomerForm from '_modules/customer/components/CustomerForm.vue';
import ModalTemplate from '_shared/Modal.vue';
import { MODEL, _LOAD_MODEL_ } from '_modules/customer/components/CustomerModel';

export default {
  data() {
    return {
      forgot: {
        email: null,
        error: false,
      },
      loading: false,
    };
  },
  components: {
    Loader,
    CustomerForm,
    ModalTemplate,
  },
  methods: {
    save() {
      this.$refs.customerForm.save();
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$emit(_LOAD_MODEL_, MODEL);
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
      max-width: 1100px;
  }
}
</style>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
